import { createFileRoute } from "@tanstack/react-router";
import { RelationsQueueScreen } from "../components/relations/RelationsQueueScreen";

export const Route = createFileRoute("/_auth/relations/")({
  staticData: {
    titleKey: "relations.queue.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 7,
  },
  component: RelationsQueueScreen,
});
